import React from "react";
import "./confirmationmodal.scss";
import { Row, Col } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Link } from "react-router-dom";

const ConfirmationModal = (props) => {
  return (
    <div className="parent-confirmation">
      <Row>
        <Col>
          <div className="confirmation-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      {props.popup === "SaveBeneficiaries" ? (
        <Row className="save-text-align">
          <Col>
            <Icons
              iconname="tick-green"
              variant="icon-sixty-px"
              clickHandler={props.handleCloseButton}
            />
          </Col>
        </Row>
      ) : (
        ""
      )}
      <Row style={{ paddingLeft: "12px" }}>
        <Col
          className={
            props.popup === "SaveBeneficiaries" ? "save-text-align" : "mb-4"
          }
        >
          <div className="confirm-heading">{props.heading}</div>
        </Col>
      </Row>
      <Row style={{ paddingLeft: "12px" }}>
        <Col
          className={
            props.popup === "SaveBeneficiaries" ? "save-text-align mb-3" : ""
          }
        >
          <span
            className={
              props.popup === "SaveBeneficiaries"
                ? "saved-text"
                : "confirm-details"
            }
          >
            {props.details}
          </span>
        </Col>
      </Row>
      <Row style={{ paddingLeft: "12px" }}>
        <Col>
          <div
            className={
              props.popup === "SaveBeneficiaries"
                ? "save-text-align"
                : "parent-button mb-4"
            }
          >
            {props.popup !== "SaveBeneficiaries" ? (
              props.popup === "AddBeneficiary" ? (
                <div className="add-beneficiaries-button">
                  <Buttons
                    className="primary"
                    name={props.cancelButton}
                    handleClick={props.cancelHandler}
                  />
                </div>
              ) : (
                <div className="popup-primary-button">
                  <Buttons
                    className="secondary"
                    name={props.cancelButton}
                    handleClick={props.cancelHandler}
                  />
                </div>
              )
            ) : (
              ""
            )}
            {props.popup === "DeleteBeneficiary" ||
            props.popup === "CancelBeneficiary" ||
            props.popup === "SaveBeneficiaries" ? (
              <div>
                <Buttons
                  className="primary"
                  name={props.confirmButton}
                  handleClick={props.confirmHandler}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ConfirmationModal;
